import React, {
  useState,
  useEffect,
  useContext
} from 'react'

import * as Contexts from '../../contexts'
import * as Page from '../../components/Page'
import * as Components from './components'
import { useHttp } from '../../hooks/http.hook'

import {
  config,
  Translater
} from '../../config'

import { IStaff } from '../../types/items'


const IndexPage: React.FC = () => {

  const { token } = useContext(Contexts.AuthContext)
  const { access } = useContext(Contexts.UserContext)
  const { language } = useContext(Contexts.LanguageContext)

  const { loading, request } = useHttp()

  const [primary, setPrimary] = useState<IStaff[]>([])

  const Events = {
    reloadHandler: () => {
      Callbacks.Fetch()
    }
  }

  const Callbacks = {
    Fetch: async () => {
      try {
        const response: IStaff[] = await request(`${config.API}/admins`,
          'GET', null, {
          Authorization: (token as string)
        })

        if (response) {
          setPrimary(response)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  useEffect(() => {
    Callbacks.Fetch()
  }, [])


  if (loading || !primary) return <Page.Preloader />

  return (
    <Page.Wrapper
      title={Translater.StaffPage.title[language.slug]}
    >
      <Page.Header
        title={Translater.StaffPage.title[language.slug]}
        enableButton={access.admin?.children?.staff?.rule === 'change'}
        linkTitle={Translater.Buttons.create[language.slug]}
        linkTo='/staff/create'
      />

      <Components.Table
        items={primary}
        reloadHandler={Events.reloadHandler}
      />
    </Page.Wrapper>
  )
}

export default IndexPage